// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__Njh3K","h2":"Heading_h2__c7awF"};